import React, { useCallback, useMemo, useState } from "react";
import style from "./ClinicalResources.module.scss";
import { Modal } from "../../../secondary";
import { buildBreadcrumbTrail, CLINICAL_RESOURCES_LIST, OR_AND_STRECHER_LIST, RESOURCE_FLOWS, VIEW } from "./constant";
import { ResourceCard } from "./ResourceCard";
import { ProteinCalculator } from "./ProteinCalculator";
import { Breadcrumb } from "./Breadcrumb";
import { ORStretcherPads } from "./ORStretcherPads/ORStretcherPads";

const getActiveResourceKey = (view) => {
  if (view === VIEW.MAIN) return null;
  return Object.keys(RESOURCE_FLOWS).find((key) => RESOURCE_FLOWS[key].views.includes(view)) || null;
};

export const ClinicalResources = ({ modalOpen, onClose }) => {
  const [view, setView] = useState(VIEW.MAIN);

  const activeResourceKey = useMemo(() => getActiveResourceKey(view), [view]);
  const trail = useMemo(() => buildBreadcrumbTrail(view), [view]);

  const handleResourceSelect = useCallback((key) => {
    const flow = RESOURCE_FLOWS[key];
    if (flow) setView(flow.entryView);
  }, []);

  const handleNavigate = useCallback((targetView) => setView(targetView), []);

  const handleModalClose = useCallback(() => {
    setView(VIEW.MAIN);
    onClose?.();
  }, [onClose]);

  const heading = view !== VIEW.MAIN ? RESOURCE_FLOWS[activeResourceKey]?.title : "Clinical Resources";

  return (
    <Modal modalOpen={modalOpen} modalClose={handleModalClose} heading={heading} modalSize={style.custom_modal_size} custom_heading="pt-0">
      <Breadcrumb trail={trail} onNavigate={handleNavigate} />

      <div className={style.viewport} key={activeResourceKey || "main"}>
        {view === VIEW.MAIN && (
          <div className={style.resourceGrid}>
            {CLINICAL_RESOURCES_LIST.map((resource) => (
              <ResourceCard key={resource.key} resource={resource} onClick={handleResourceSelect} />
            ))}
          </div>
        )}

        {activeResourceKey === "protein" && <ProteinCalculator view={view} setView={setView} />}
        {activeResourceKey === "stretcherPads" && <ORStretcherPads view={view} setView={setView} />}
      </div>
    </Modal>
  );
};
